import { LocalizedParagraph, useDialogs } from '@mews-commander/ui';
import { Button, Dialog, Stack } from '@optimus-web/core';
import { LocalizedText, showSuccessAlert } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { useDisablePinMutation } from '../../../queries/useDisablePinMutation';

export const PIN_DISABLE_DIALOG_NAME = 'pinDisableDialog';

export const PinDisableDialog = () => {
    const { closeDialog } = useDialogs();

    const handleClose = () => closeDialog(PIN_DISABLE_DIALOG_NAME);

    const { mutate, isPending } = useDisablePinMutation({
        onSuccess: () => {
            handleClose();

            showSuccessAlert({
                title: <LocalizedText textKey={TextKey.PinDeleteSuccessTitle} />,
                description: <LocalizedText textKey={TextKey.PinDeleteSuccessDescription} />,
            });
        },
    });

    return (
        <Dialog
            active
            size="small"
            loading={isPending}
            title={<LocalizedText textKey={TextKey.PinDelete} />}
            onClose={handleClose}
            footer={{
                secondary: (
                    <Button type="button" onClick={handleClose} variant="tertiary">
                        <LocalizedText textKey={TextKey.Cancel} />
                    </Button>
                ),
                primary: (
                    <Button onClick={() => mutate()} variant="primary" type="submit">
                        <LocalizedText textKey={TextKey.Delete} />
                    </Button>
                ),
            }}
        >
            <Stack vertical spacing="200">
                <LocalizedParagraph textKey={TextKey.PinDeleteDescription} />
            </Stack>
        </Dialog>
    );
};
